export function getParent(elm, selector) {
	let cur = elm.parentNode;
	if (selector && selector.nodeType) {
		while (cur && cur !== selector) {
			cur = cur.parentNode;
		}
	} else {
		const alls = document.queryAll(selector);
		while (cur && alls.indexOf(cur) === -1) {
			cur = cur.parentNode;
		}
	}

	return cur;
}

export function target(elm, selector) {
	if (selector && selector.nodeType) {
		if (elm === selector) {
			return elm;
		}
	} else if (elm.matches && elm.matches(selector)) {
		return elm;
	}

	const parent = getParent(elm, selector);
	if (parent) {
		return parent;
	}
}
